import {
  DockedPanel,
  type TimelineActivityGroupMetadata,
  useDockedPanelActions,
} from '../../../../contexts/DockedPanelContext'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'
import {useEffectiveSelection} from '../../data/use-effective-selection'

export const useSidebarActivityOpenTimeline = () => {
  const {openPanel} = useDockedPanelActions()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const {sinceSelectors} = useEffectiveSelection()

  return (returnFocusTo: HTMLElement | null, activityGroup?: TimelineActivityGroupMetadata) => {
    sendPullRequestAnalyticsEvent('overview.activity_timeline_open', 'OVERVIEW_TIMELINE_BUTTON')
    openPanel(DockedPanel.Timeline, {
      metadata: {activityGroup, timelineSinceSelectors: sinceSelectors},
      returnFocusTo,
    })
  }
}
